<!--
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
-->
<!--
  Program: Bread crumb
  Author: SDL
  Brief: Components that visually show where the current user is
-->
<template>
  <div class="ui--content-heading">
    <strong>{{ title }}</strong>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb float-right">
        <li class="breadcrumb-item" v-if="home">
          <router-link :to="{ name: 'mainIndexPage' }">{{ homeText }}</router-link>
        </li>
        <li
          class="breadcrumb-item"
          :class="{ active: index === list.length - 1 }"
          v-for="(item, index) in list"
          :key="item.menuId"
        >
          <a>{{ getLabel(item) }}</a>
          <!-- <a :href="'' !== item.menuUrl && item.menuUrl ? item.menuUrl : 'javascript:'">{{item.localeLabel}}</a> -->
          <!-- <router-link v-if="index === list.length - 1" :to="item.menuUrl" tag="span">{{item.localeLabel}}</router-link>
          <a :href="'' !== item.menuUrl && item.menuUrl ? item.menuUrl : 'javascript:'" v-else>{{item.localeLabel}}</a> -->
        </li>

        <!-- <li class="breadcrumb-item"><a href="#">Menu1</a></li>
        <li class="breadcrumb-item"><a href="#">Submenu1</a></li>
        <li class="breadcrumb-item active" aria-current="page">Submenu1-1</li> -->
      </ol>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import SDLLocale from '@/mixin/SDLLocale';

export default {
  name: 'Breadcrumb',
  mixins: [SDLLocale],
  props: {
    home: {
      required: false,
      type: Boolean,
      default: false,
    },
    homeText: {
      required: false,
      type: String,
      default: 'Home',
    },
  },
  data() {
    return {
      title: '',
      list: [],
    };
  },
  computed: {
    ...mapGetters({
      menus: 'getMenus',
    }),
    menu() {
      return _.find(this.menus, ['menuId', this.menuId]);
    },
    menuId() {
      return this.$route.meta.menuId;
    },
    pageId() {
      return this.$route.meta.pageId;
    },
  },
  watch: {
    menus() {
      this.setTitle();
      this.setBreadcrumb();
    },
    locale() {
      this.setTitle();
    },
    $route() {
      this.setTitle();
      this.setBreadcrumb();
    },
  },
  methods: {
    getParentMenu(parentId) {
      return this.menus.find(item => item.menuId === parentId);
    },
    setTitle() {
      if (this.menu) {
        this.title = this.getLabel(this.menu);
        // this.title = this.menu.localeLabel;
      }
    },
    setBreadcrumb() {
      if (this.menu) {
        this.list = [this.menu];
        for (let i = this.menu.menuLevel - 1; i > 0; i -= 1) {
          const parentMenu = this.getParentMenu(this.list[0].parentId);
          if (parentMenu) {
            this.list = [parentMenu, ...this.list];
          }
        }
      }
    },
  },
  created() {
    this.setTitle();
    this.setBreadcrumb();
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/common/control/breadcrumb/Breadcrumb.vue